import Button from '@components/Button';
import ModalText from '@components/ModalText';
import Prose from '@components/Prose';
import { CtaType } from '@data/types';
import useStore from '@store/store';
import React, { useEffect, useState } from 'react';
import { generatePDF } from 'utilities/generatePdf';

interface Props extends CtaType {
  as?: keyof JSX.IntrinsicElements;
}

const Cta: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
  button,
}) => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  const { setGeneratingPDF } = useStore();

  useEffect(() => {
    if (displayModal) {
      setGeneratingPDF(true);
      setTimeout(async () => {
        await generatePDF();
        setDisplayModal(false);
        setGeneratingPDF(false);
      }, 1000);
    }
  }, [displayModal]);

  return (
    <>
      <Component className="w-full bg-gradient-to-t from-5% from-blue to-red flex">
        <div className="p-4 xl:px-0 py-8 lg:py-16 w-full lg:w-2/4 max-w-innerGrid h-full flex gap-4 flex-col mx-auto justify-center">
          <div className="w-full lg:w-3/4 mx-auto">
            <Prose htmlContent={htmlContent} style="style-6" />
          </div>
          <Button
            {...button}
            className="lg:max-w-[75%] mx-auto"
            type="button"
            onClick={() => setDisplayModal(!displayModal)}
          />
        </div>
      </Component>
      {displayModal && (
        <ModalText
          setDisplayModal={setDisplayModal}
          displayModal={displayModal}
          message={'Generating PDF...'}
        />
      )}
    </>
  );
};

export default Cta;
